// WMCE-455: Reduced muster initialization -- full-muster initializing 1331 variables
import muster from '@dbk-legacy/muster';
import musterHistory from '@dbk-legacy/muster/history';
import { ref } from '@dbk-legacy/muster/utils';

import routeConfig from '../components/app/app.routes';

import roster from '@dbk-legacy/roster-client';
import rosterEbanking from '@dbk-legacy/roster-modules-ebanking/src/client';
import settings from '../data/get-settings';

import screen from './screen';
import i18n from './i18n';
import deviceRoutes from './device';
import settingsRoutes from './settings';

import rosterRoutes from './app/global/roster';
import deviceInfoRoutes from './app/global/device-info';
import authRoutes from './app/auth/auth.web';
import portfoliosRoutes from './app/user/portfolios';
import entitlementRoutes from './app/user/entitlement';
import profileRoutes from './app/user/profile';
import rsaRoutes from './app/rsa/rsa';
import searchRoutes from './app/search/search';

import uiRoutes from './ui';
import inactiveRoutes from './inactive';
import debugRoutes from './debug';
import currenciesRoutes from './currencies';
import advicesRoutes from './advices';
import portfolioRoutes from './portfolio';
import equitiesRoutes from './equities';
import bondsRoutes from './bonds';
import variousRoutes from './various';
import alternativesRoutes from './alternatives';
import cashRoutes from './cash';
import fxForwardsRoutes from './fx-forwards';
import optionsDerivativesRoutes from './options-derivatives';
import loansRoutes from './loans';
import mmInstrumentsRoutes from './mm-instruments';
import maturitiesRoutes from './maturities-routes';

import incomeExpenseRoutes from './income-expense';
import consolidationRoutes from './consolidation';
import reportsRoutes from './reports';
import transactAdvicesRoutes from './transaction-advices';
import investmentRoutes from './investment';
import detailsRoutes from './details';
import downloadRoutes from './downloads';
import cioinsightsRoutes from './cioinsights';
import notificationsRoutes from './notifications';
import rmcallbackRoutes from './rmcallback';
import marque from './marque';
import feedbackRoutes from './feedback';
import vascoRoutes from './vascoauthentication';
import discovery from './discovery';
import language from './language';
import extended from './@extended';
import genericAssetsRoutes from './genericAssets';
import priceHistory from './price-history.ch';
import eDelivery from './edelivery';
import transactionsRoutes from './transaction/transactions';
import payments from './app/payments';
import resetCode from './reset-code';
import reportschRoutes from './reportsch';
import docSignCenterRoutes from './docsigncenter';
import docSignRoutes from './app/docsign';
import chat from './chat';
import eCredentials from './eCredentials';
import docUpload from './doc-upload';
import rmAccess from './rm-access';
import dataExports from './dataExports';
import dashboard from './dashboard';
import manageContactDetailRoutes from './manage-contact-details';
import accountInformationService from './account-information-service';
import paymentInitiationService from './payment-initiation-service';
import paperless from './paperless';
import cashAccounts from './cash-accounts';
import alerts from './alerts';
import updatePassword from './update-password';

const INITIAL_PATH = '/webindex'; // webindex

export default (modelUrl) =>
  muster()
    .import('ui.history', musterHistory(INITIAL_PATH, settings.webfolder, { routeConfig }))
    .import(null, settingsRoutes())
    .import('roster', roster([
      rosterEbanking(settings.defaultEnvironment),
    ], modelUrl), {
      'rosterEbanking.env': ref('settings.currentEnvironment.id'),
    })
    .import('i18n', i18n())
    .import(null, extended())
    .import(null, deviceRoutes())
    .import(null, screen())
    .import(null, investmentRoutes())
    .import(null, detailsRoutes())
    .import(null, incomeExpenseRoutes())
    .import(null, consolidationRoutes())
    .import(null, reportsRoutes())
    .import(null, uiRoutes())
    .import(null, inactiveRoutes())
    .import(null, currenciesRoutes())
    .import(null, advicesRoutes())
    .import(null, rosterRoutes())
    .import(null, deviceInfoRoutes())
    .import(null, authRoutes())
    .import(null, portfoliosRoutes())
    .import(null, entitlementRoutes())
    .import(null, profileRoutes())
    .import(null, rsaRoutes())
    .import(null, searchRoutes())
    .import(null, portfolioRoutes())
    .import(null, maturitiesRoutes())
    .import(null, transactAdvicesRoutes())
    .import(null, downloadRoutes())
    .import(null, cioinsightsRoutes())
    .import(null, notificationsRoutes())
    .import(null, rmcallbackRoutes())
    .import(null, marque())
    .import(null, feedbackRoutes())
    .import(null, vascoRoutes())
    .import(null, discovery())
    .import(null, language())
    .import(null, priceHistory())
    .import(null, docSignCenterRoutes())
    .import(null, docSignRoutes())
    .import(null, chat())
    .import('portfolio.alternatives', alternativesRoutes(), {
      'assetsCommon.data': ref('app.user.selectedPortfolio.alternatives'),
      'assetsCommon.portfolioData': ref('portfolio.assetsByKey.alternatives'),
      'assetsCommon.sortIsAscending': ref('ui.state.portfolio.alternatives.ascending'),
      'assetsCommon.sortByKey': ref('ui.state.portfolio.alternatives.selectedKey'),
      'assetsCommon.static': ref('ui.static.alternatives'),
      'assetsCommon.state': ref('ui.state.portfolio.alternatives'),
      'assetsCommon.search': ref('search'),
    })
    .import('portfolio.bonds', bondsRoutes(), {
      'assetsCommon.data': ref('app.user.selectedPortfolio.bonds'),
      'assetsCommon.portfolioData': ref('portfolio.assetsByKey.bonds'),
      'assetsCommon.sortIsAscending': ref('ui.state.portfolio.bonds.ascending'),
      'assetsCommon.sortByKey': ref('ui.state.portfolio.bonds.selectedKey'),
      'assetsCommon.static': ref('ui.static.bonds'),
      'assetsCommon.state': ref('ui.state.portfolio.bonds'),
      'assetsCommon.search': ref('search'),
    })
    .import('portfolio.equities', equitiesRoutes(), {
      'assetsCommon.data': ref('app.user.selectedPortfolio.equities'),
      'assetsCommon.portfolioData': ref('portfolio.assetsByKey.equities'),
      'assetsCommon.sortIsAscending': ref('ui.state.portfolio.equities.ascending'),
      'assetsCommon.sortByKey': ref('ui.state.portfolio.equities.selectedKey'),
      'assetsCommon.static': ref('ui.static.equities'),
      'assetsCommon.state': ref('ui.state.portfolio.equities'),
      'assetsCommon.search': ref('search'),
    })
    .import('portfolio.optionsDerivatives', optionsDerivativesRoutes(), {
      'assetsCommon.data': ref('app.user.selectedPortfolio.optionsDerivatives'),
      'assetsCommon.portfolioData': ref('portfolio.assetsByKey.optionsDerivatives'),
      'assetsCommon.sortIsAscending': ref('ui.state.portfolio.optionsDerivatives.ascending'),
      'assetsCommon.sortByKey': ref('ui.state.portfolio.optionsDerivatives.selectedKey'),
      'assetsCommon.static': ref('ui.static.optionsDerivatives'),
      'assetsCommon.state': ref('ui.state.portfolio.optionsDerivatives'),
      'assetsCommon.search': ref('search'),
    })
    .import('portfolio.various', variousRoutes(), {
      'assetsCommon.data': ref('app.user.selectedPortfolio.various'),
      'assetsCommon.portfolioData': ref('portfolio.assetsByKey.various'),
      'assetsCommon.sortIsAscending': ref('ui.state.portfolio.various.ascending'),
      'assetsCommon.sortByKey': ref('ui.state.portfolio.various.selectedKey'),
      'assetsCommon.static': ref('ui.static.various'),
      'assetsCommon.state': ref('ui.state.portfolio.various'),
      'assetsCommon.search': ref('search'),
    })
    .import('portfolio.mmInstruments', mmInstrumentsRoutes(), {
      'assetsCommon.data': ref('app.user.selectedPortfolio.mmInstruments'),
      'assetsCommon.portfolioData': ref('portfolio.assetsByKey.mmInstruments'),
      'assetsCommon.sortIsAscending': ref('ui.state.portfolio.mmInstruments.ascending'),
      'assetsCommon.sortByKey': ref('ui.state.portfolio.mmInstruments.selectedKey'),
      'assetsCommon.static': ref('ui.static.mmInstruments'),
      'assetsCommon.state': ref('ui.state.portfolio.mmInstruments'),
      'assetsCommon.search': ref('search'),
    })
    .import('portfolio.cash', cashRoutes(), {
      'assetsCommon.data': ref('app.user.selectedPortfolio.cash'),
      'assetsCommon.portfolioData': ref('portfolio.assetsByKey.cash'),
      'assetsCommon.sortIsAscending': ref('ui.state.portfolio.cash.ascending'),
      'assetsCommon.sortByKey': ref('ui.state.portfolio.cash.selectedKey'),
      'assetsCommon.static': ref('ui.static.cash'),
      'assetsCommon.state': ref('ui.state.portfolio.cash'),
      'assetsCommon.search': ref('search'),
    })
    .import('portfolio.fxForwards', fxForwardsRoutes(), {
      'assetsCommon.data': ref('app.user.selectedPortfolio.fxForwards'),
      'assetsCommon.portfolioData': ref('portfolio.assetsByKey.fxForwards'),
      'assetsCommon.sortIsAscending': ref('ui.state.portfolio.fxForwards.ascending'),
      'assetsCommon.sortByKey': ref('ui.state.portfolio.fxForwards.selectedKey'),
      'assetsCommon.static': ref('ui.static.fxForwards'),
      'assetsCommon.state': ref('ui.state.portfolio.fxForwards'),
      'assetsCommon.search': ref('search'),
    })
    .import('portfolio.loans', loansRoutes(), {
      'assetsCommon.data': ref('app.user.selectedPortfolio.loans'),
      'assetsCommon.portfolioData': ref('portfolio.assetsByKey.loans'),
      'assetsCommon.sortIsAscending': ref('ui.state.portfolio.loans.ascending'),
      'assetsCommon.sortByKey': ref('ui.state.portfolio.loans.selectedKey'),
      'assetsCommon.static': ref('ui.static.loans'),
      'assetsCommon.state': ref('ui.state.portfolio.loans'),
      'assetsCommon.search': ref('search'),
    })
    .import('portfolio.genericAssets', genericAssetsRoutes(), {
      'assetsCommonCh.data': ref('app.user.selectedPortfolio.genericAssets'),
      'assetsCommonCh.portfolioData': ref('portfolio.assetsByKey.genericAssets'),
      'assetsCommonCh.sortIsAscending': ref('ui.state.portfolio.genericAssets.ascending'),
      'assetsCommonCh.sortByKey': ref('ui.state.portfolio.genericAssets.selectedKey'),
      'assetsCommonCh.static': ref('ui.static.genericAssets'),
      'assetsCommonCh.state': ref('ui.state.portfolio.genericAssets'),
      'assetsCommonCh.search': ref('search'),
      'assets.config.pageSize':ref('app.config.assetPageSize'),
    })
    .import(null, debugRoutes())
    .import(null, eDelivery())
    .import(null, transactionsRoutes())
    .import(null, payments())
    .import(null, resetCode())
    .import(null, reportschRoutes())
    .import(null, eCredentials())
    .import(null, rmAccess())
    .import(null, docUpload())
    .import(null, dataExports())
    .import(null, dashboard())
    .import(null, manageContactDetailRoutes())
    .import(null, accountInformationService())
    .import(null, paymentInitiationService())
    .import(null, paperless())
    .import(null, cashAccounts())
    .import(null, alerts())
    .import(null, updatePassword())
